import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { copyToClipboard } from 'helpers/clipboard.helper';
import { useLogger } from 'hook/error.hook';
import { useFlag } from 'hook/flag.hook';
import React from 'react';
import { DIRECT_DEPOSIT_MANUAL } from 'types/morph.pagePosition.constants';
import DirectDepositManualView from './DirectDepositManualView';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

const DirectDepositManualController = props => {
  const { eventHandler, userInfo, cashAccount } = props;
  const logger = useLogger({ name: 'DirectDepositManualController' });
  const atr = getViewModuleTrackingAttributes({
    pagePosition: DIRECT_DEPOSIT_MANUAL,
    modulePosition: 1,
    moduleType: DIRECT_DEPOSIT_MANUAL,
    vertical: BANKING_VERTICAL,
  });
  const cashFlag = useFlag('cash');
  const config = cashFlag?.config?.module_direct_deposit_manual ?? {};
  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  const onClickCopyField = (title, value) => {
    eventHandler(CLICK, {
      'Click Type': `Copy ${title}`,
      Vertical: BANKING_VERTICAL,
      ...atr,
    });
    logger.showSuccess(`Copied the ${title.toLowerCase()}.`, null, {
      notClosable: true,
    });
    copyToClipboard(value);
  };

  return (
    <DirectDepositManualView
      {...config}
      onClickCopyField={onClickCopyField}
      customerName={userInfo && `${userInfo.firstName} ${userInfo.lastName}`}
      routingNumber={cashAccount && cashAccount.routingNumber}
      accountNumber={cashAccount && cashAccount.ddaNumber}
      seenPixel={seenPixel}
    />
  );
};

export default DirectDepositManualController;
